module.exports = __webpack_public_path__ + "static/media/2 1 ordkjedetekst.2a1f306a.mp3";